import dkScreen1 from '@client/shared/images/landingPageAssets/dk/smartphone-screen-1.png';
import dkScreen2 from '@client/shared/images/landingPageAssets/dk/smartphone-screen-2.png';
import dkScreen3 from '@client/shared/images/landingPageAssets/dk/smartphone-screen-3.png';
import dkScreen4 from '@client/shared/images/landingPageAssets/dk/smartphone-screen-4.png';
import noScreen1 from '@client/shared/images/landingPageAssets/no/smartphone-screen-1.png';
import noScreen2 from '@client/shared/images/landingPageAssets/no/smartphone-screen-2.png';
import noScreen3 from '@client/shared/images/landingPageAssets/no/smartphone-screen-3.png';
import noScreen4 from '@client/shared/images/landingPageAssets/no/smartphone-screen-4.png';
import svScreen1 from '@client/shared/images/landingPageAssets/sv/smartphone-screen-1.png';
import svScreen2 from '@client/shared/images/landingPageAssets/sv/smartphone-screen-2-v2.png';
import svScreen3 from '@client/shared/images/landingPageAssets/sv/smartphone-screen-3.png';
import svScreen4 from '@client/shared/images/landingPageAssets/sv/smartphone-screen-4.png';
import enScreen1 from '@client/shared/images/landingPageAssets/en/smartphone-screen-1.png';
import enScreen2 from '@client/shared/images/landingPageAssets/en/smartphone-screen-2.png';
import enScreen3 from '@client/shared/images/landingPageAssets/en/smartphone-screen-3.png';
import enScreen4 from '@client/shared/images/landingPageAssets/en/smartphone-screen-4.png';

export const getImagesByLanguage = (language = 'sv') => {
  switch (language) {
    case 'sv':
      return {
        screen1: svScreen1,
        screen2: svScreen2,
        screen3: svScreen3,
        screen4: svScreen4,
      };
    case 'dk':
      return {
        screen1: dkScreen1,
        screen2: dkScreen2,
        screen3: dkScreen3,
        screen4: dkScreen4,
      };
    case 'no':
      return {
        screen1: noScreen1,
        screen2: noScreen2,
        screen3: noScreen3,
        screen4: noScreen4,
      };
    case 'en':
      return {
        screen1: enScreen1,
        screen2: enScreen2,
        screen3: enScreen3,
        screen4: enScreen4,
      };
    default:
      return {
        screen1: svScreen1,
        screen2: svScreen2,
        screen3: svScreen3,
        screen4: svScreen4,
      };
  }
};
